// import "../../styling/style.css";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Formik, FormikErrors } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { requestAndReplyRevision } from "../../api/FileRevision";
import { getBase64GeneratePdfSuratPersetujuanMaster } from "../../api/GenerateBase64PdfSuratPersetujuanMaster";
import AutocompleteComponent from "../../components/autocomplete/autocomplete-mui";
import CommentDisabledComponent from "../../components/commentdisabled/comment-disabled-mui";
import ConfirmationDialogComment from "../../components/confirmationdialogcomment/confirmation-dialog-comment";
import ConfirmationDialogRevisionLegal from "../../components/confirmationdialogrevisionlegal/confirmation-dialog-revision-legal";
import ConfirmationDialogRevisionUser from "../../components/confirmationdialogrevisionuser/confirmation-dialog-revision-user";
import CRRNumberField from "../../components/crrnumberfield/crr-number-field-mui";
import ConfirmationDialog from "../../components/dialog/simple-alert";
import DropdownlistComponent from "../../components/dropdownlist/dropdownlist-mui";
import DropdownlistComponentValidation from "../../components/dropdownlistvalidation/dropdownlist-validation-mui";
import Feedback from "../../components/feedback/feedback";
import Loading from "../../components/loading/loading";
import RevisionDisabledComponent from "../../components/revisiondisabled/revision-by-end-user-disabled-mui";
import TextAreaComponent from "../../components/textarea/textarea-mui";
import TextFieldComponent from "../../components/textfield/textfield-mui";
import TextFieldDateComponent from "../../components/textfielddate/textfield-date-mui";
import TextFieldDateValidationComponent from "../../components/textfielddatevalidation/textfield-date-validation-mui";
import TextFieldDisabledComponent from "../../components/textfielddisabled/textfield-disabled-mui";
import TextFieldMultiComponent from "../../components/textfieldmulti/textfield-multi-mui";
import TextFieldMultiDisabledComponent from "../../components/textfieldmultidisabled/textfield-multi-disabled-mui";
import UploadMultipleFileComponent from "../../components/uploadmultiplefile/UploadMultipleFile";
import {
  IDataComment,
  IRevisionLegalComment,
} from "../../interfaces/IDataComment";
import { IDataRevision } from "../../interfaces/IDataRevision";
import { IDataUploadComment } from "../../interfaces/IDataUploadComment";
import { NewIDataUploadItem } from "../../interfaces/IDataUploadItem";
import { IForm } from "../../interfaces/IForm";
import { TransactionHistoryModal } from "../../shared/Components/TransactionHistoryModal";
import { DocumentType, RequestStatus, RequestType } from "../../shared/Enum";
import { RoleStatus } from "../../shared/Enum/RoleStatus";
import {
  FilterDistinctByIdAndSort,
  RemoveDateFromFileName,
} from "../../shared/functions";

import { selectUserProfile, selectUserRole } from "../../store/auth/selector";
import { homeStyle } from "../../styles/container/home";
import {
  downloadSingleFile,
  editFormLR,
  getListAreaLocation,
  getListDocumentType,
  getListRequestType,
  getSharepointToken,
  getSingleDataRequest,
  resendEmailFinishedForm,
  sendBack,
} from "./api-endpoint/callApi";

const getBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    reader.addEventListener("error", (error) => {
      reject(error);
    });
    reader.readAsDataURL(file);
  });

function ApprovalLR() {
  const { id } = useParams();
  const [listDocumentType, setListDocumentType] = useState([]);
  const [listAreaLocation, setListAreaLocation] = useState([]);
  const [listRequestType, setListRequestType] = useState([]);
  const [validationDocumentType, setValidationDocumentType] = useState(
    DocumentType.toId(DocumentType.Softcopy)
  );
  const [validationDateOfPower, setValidationDateOfPower] = useState("");
  const [validationDateGrantOfPower, setValidationDateGrantOfPower] =
    useState("");
  const [validationRequestType, setValidationRequestType] = useState(
    RequestType.toId(RequestType.SuratKuasa)
  );
  const [validationSignerAndLeader, setValidationSignerAndLeader] =
    useState(false);
  const [validationNeedRealization, setValidationNeedRealization] =
    useState(false);
  const [sharepoint, setSharepoint] = useState<any>({ token: "", expToken: 0 });
  const [errorUpload, setErrorUpload] = useState("");
  const [errorUploadSK, setErrorUploadSK] = useState("");
  const [errorUploadRealizationDM, setErrorUploadRealizationDM] = useState("");

  const [globalDocumentType, setGlobalDocumentType] = useState("");
  const [formData, setFormData] = useState<IForm | undefined>();
  const [actionClick, setActionClick] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openConfirmationRevision, setOpenConfirmationRevision] =
    useState(false);
  const [openConfirmationRevisionLegal, setOpenConfirmationRevisionLegal] =
    useState(false);
  const [openConfirmationSubmit, setOpenConfirmationSubmit] = useState(false);
  const [openConfirmationResend, setOpenConfirmationResend] = useState(false);
  const [loadingActive, setLoadingActive] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [openFeedback, setOpenFeedback] = useState(false);
  const [comment, setComment] = useState("");
  const [requestDate, setRequestDate] = useState("");
  const [requestStatusID, setRequestStatusID] = useState("");
  const [updateStatusIDOnSubmit, setUpdateStatusIDOnSubmit] = useState("");
  const [requestStatusName, setRequestStatusName] = useState("");
  const [listDataRevision, setListDataRevision] = useState<IDataRevision[]>([]);
  const [crrNumber, setCrrNumber] = useState("");
  const [crrNumError, setCrrError] = useState("");
  const [requestTypeId, setRequestTypeId] = useState("");

  const [saveAndSendConfirmationSubmit, setSaveAndSendConfirmationSubmit] =
    useState(false);
  const [saveAndSendConfirmationValue, setSaveAndSendConfirmationValue] =
    useState("");

  const [resendConfirmationSubmit, setResendConfirmationSubmit] =
    useState(false);
  const [resendConfirmationValue, setResendConfirmationValue] = useState("");
  const [userRevision, setUserRevision] = useState(0);

  const [dataUpload, setDataUpload] = useState<NewIDataUploadItem[]>([
    {
      title: "Unggah Draft Final / Upload Final Draft*",
      fileType: "Draft Final",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [uploadSK, setUploadSK] = useState<NewIDataUploadItem[]>([
    {
      title: "Unggah SK / Upload SK*",
      fileType: "Hardcopy SK",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [fileSuratPersetujuanGeneratePdf, setFileSuratPersetujuanGeneratePdf] =
    useState<NewIDataUploadItem[]>([
      {
        title: "",
        fileType: "Surat Persetujuan Penggunaan Master Dokumen",
        files: [
          {
            documentID: "",
            fileBase64: "",
            fileName: "",
            folderName: "",
          },
        ],
      },
    ]);

  const [uploadRealizationDM, setUploadRealizationDM] = useState<
    NewIDataUploadItem[]
  >([
    {
      title:
        "Unggah Realisasi Dokumen Master / Upload Master Document Realization*",
      fileType: "Master Document Realization",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [tempRevisionData, setTempRevisionData] = useState<{
    comment: string;
    data: NewIDataUploadItem[];
  }>({
    comment: "",
    data: [
      {
        title: "Bukti / Evidence",
        fileType: "Evidence",
        files: [
          { documentID: "", fileBase64: "", fileName: "", folderName: "" },
        ],
      },
    ],
  });

  const [legalRevisionData, setLegalRevisionData] =
    useState<IRevisionLegalComment>({
      comment: "",
      attachments: [
        {
          title: "Bukti / Evidence",
          fileType: "Evidence",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        },
      ],
    });

  const [dataUploadComment, setDataUploadComment] =
    useState<IDataUploadComment>({
      commentID: "",
      fileBase64: "",
      fileName: "",
    });
  const [actionButtonClick, setActionButtonClick] = useState("");
  const [actionButtonClickRevision, setActionButtonClickRevision] =
    useState("");
  const [dataCommentEndUser, setDataCommentEndUser] = useState<IDataComment[]>(
    []
  );
  const [dataCommentCL, setDataCommentCL] = useState<IDataComment[]>([]);
  const [requestNumber, setRequestNumber] = useState("");

  const [valueTab, setValueTab] = useState(0);
  const getRole = useSelector(selectUserRole);
  const profile = useSelector(selectUserProfile);
  const today = new Date();
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const Navigate = useNavigate();

  const initialValues: IForm = {
    startDatePeriod: "",
    endDatePeriod: "",
    binusianID: profile.BinusianId,
    email: "",
    binusianName: "",
    businessUnit: "",
    department: "",
    title: "",
    buLeader: "",
    extension: "",
    documentType: DocumentType.toId(DocumentType.Softcopy),
    requestType: RequestType.toId(RequestType.SuratKuasa),
    dateOfPower: "",
    dateGrantOfPower: "",
    clNote: "",
    lrNote: "",
    signer: null,
    titleAgreement: "",
    area: "Anggrek",
    address: "",
    counterPart: "",
    requestDate: "",
    substitutor: null,
    delegatee: null,
    noPowerAttorney: "",
    noSubstitutor: "",
    needSK: "",
    needRealization: "",
  };

  const getDocumentType = async () => {
    try {
      const ltDocumentType = await getListDocumentType();
      setListDocumentType(ltDocumentType);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const getAreaLocation = async () => {
    try {
      const tempDataAreaLocation: any = [];
      const ltAreaLocation = await getListAreaLocation();
      const jsonParse = JSON.parse(ltAreaLocation);

      jsonParse.data.forEach((datas: any) => {
        tempDataAreaLocation.push({
          label: datas.locationHierarcy.text,
          value: datas.locationHierarcy.id,
        });
      });
      const distinctLocation = FilterDistinctByIdAndSort(tempDataAreaLocation);
      setListAreaLocation(distinctLocation);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const getRequestType = async () => {
    try {
      const msRequestType = await getListRequestType();
      setListRequestType(msRequestType);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  /* eslint-disable unicorn/consistent-function-scoping */
  function transformSingleData(data): any[] {
    const categoryMap = {
      "Draft Final": "Unggah Draft Final / Upload Final Draft*",
      "Approval BU Leader": "Approval BU Leader / BU Leader Approval*",
      "Partner Request": "Unggah Permohonan Partner / Upload Partner Request",
      "Master Document Realization":
        "Unggah Realisasi Dokumen Master / Upload Master Document Realization*",
      "Hardcopy SK": "Unggah SK / Upload SK*",
    };
    const categoryKey = {
      "Draft Final": 1,
      "Approval BU Leader": 2,
      "Partner Request": 3,
      "Master Document Realization": 4,
      "Hardcopy SK": 5,
    };
    const orderedCategoryKeys = Object.keys(categoryKey).sort(
      (a, b) => categoryKey[a] - categoryKey[b]
    );

    const groupedData = data.reduce((acc, item) => {
      const { category, documentID, documentName, link } = item;
      const newTitleName = categoryMap[category] || category;
      const newCategory = categoryKey[category]
        ? category
        : categoryKey[category];
      acc[newCategory] = acc[newCategory] || {
        title: newTitleName,
        fileType: category,
        files: [],
      };
      acc[newCategory].files.push({
        documentID,
        fileBase64: "",
        fileName: documentName,
        folderName: link,
      });
      return acc;
    }, {});

    return orderedCategoryKeys
      .map((key) => groupedData[key])
      .filter((item) => item !== undefined);
  }
  /* eslint-enable unicorn/consistent-function-scoping */

  // eslint-disable-next-line consistent-return
  const getSingleData = async () => {
    try {
      // get all data for table list User
      const getSingleRequest = await getSingleDataRequest(id);
      setRequestStatusName(getSingleRequest.trRequest.requestStatusName);
      setCrrNumber(getSingleRequest.trRequest.noCRR);
      setRequestTypeId(getSingleRequest.trRequest.requestTypeID);
      if (getSingleRequest.trRequest.userRevision > 0) {
        setUserRevision(getSingleRequest.trRequest.userRevision);
      }
      // Validation Access Page
      if (
        (getRole.roleId != "RL230000004" && getRole.roleId != "RL230000001") ||
        (getSingleRequest.trRequest.requestStatusID !=
          RequestStatus.toId(RequestStatus.AwaitingConfirmation) &&
          getSingleRequest.trRequest.requestStatusID !=
            RequestStatus.toId(RequestStatus.Finished) &&
          getSingleRequest.trRequest.requestStatusID !=
            RequestStatus.toId(RequestStatus.FinishedRevised))
      ) {
        Navigate("/");
      }

      setRequestStatusID(getSingleRequest.trRequest.requestStatusID);
      setRequestNumber(getSingleRequest.trRequest.requestNumber);

      // profile
      initialValues.binusianName = getSingleRequest.trRequest.binusianName;
      initialValues.businessUnit = getSingleRequest.trRequest.businessUnit;
      initialValues.department = getSingleRequest.trRequest.department;
      initialValues.title = getSingleRequest.trRequest.title;
      initialValues.buLeader = getSingleRequest.trRequest.buLeader;
      initialValues.extension = getSingleRequest.trRequest.ext;
      // case Soft Copy
      setRequestDate(
        moment(getSingleRequest.trRequest.requestDate).format("DD MMMM YYYY")
      );
      initialValues.dateOfPower = moment(
        getSingleRequest.trRequest.poaDate
      ).format("YYYY-MM-DD");
      setValidationDateOfPower(getSingleRequest.trRequest.poaDate);
      if (getSingleRequest.trRequest.dateGrantOfPower !== null) {
        initialValues.dateGrantOfPower = moment(
          getSingleRequest.trRequest.dateGrantOfPower
        ).format("YYYY-MM-DD");
        setValidationDateGrantOfPower(
          getSingleRequest.trRequest.dateGrantOfPower
        );
        initialValues.clNote = getSingleRequest.trRequest.clNote;
        initialValues.lrNote = getSingleRequest.trRequest.lrNote;
        // setNoteGrantDate(getSingleRequest.trRequest.grantNote);
        // if (
        //   getSingleRequest.trRequest.dateGrantOfPower <=
        //   getSingleRequest.trRequest.poaDate
        // ) {
        //   setEnableNoteGrantDate(false);
        // } else {
        //   setEnableNoteGrantDate(true);
        // }
      }
      initialValues.signer = {
        binusianIDEmail: getSingleRequest.trRequest.signer.split("#")[0],
        name: getSingleRequest.trRequest.signer.split("#")[1],
      };
      const newSK = getSingleRequest?.trRequest?.needSK?.toString() ?? "false";
      initialValues.needSK = newSK;
      setFormData({ ...initialValues, needSK: newSK });
      if (
        // getSingleRequest.trRequest.signer.split("#")[0].split("~")[1].trim() ==
        // getSingleRequest.trRequest.buLeaderBinusianID.trim()
        newSK == "false"
      ) {
        setValidationSignerAndLeader(true);
      }
      const realizationValidation =
        getSingleRequest?.trRequest?.needRealization?.toString() ?? "false";
      initialValues.needRealization = realizationValidation;
      if (realizationValidation == "false") {
        setValidationNeedRealization(true);
      }
      initialValues.titleAgreement = getSingleRequest.trRequest.titleAgreement;
      initialValues.counterPart = getSingleRequest.trRequest.counterpart;
      initialValues.documentType = getSingleRequest.trRequest.documentTypeID;
      if (getSingleRequest.trRequest.startMasterUsePeriod !== null) {
        initialValues.startDatePeriod = moment(
          getSingleRequest.trRequest.startMasterUsePeriod
        ).format("YYYY-MM-DD");
        initialValues.endDatePeriod = moment(
          getSingleRequest.trRequest.endMasterUsePeriod
        ).format("YYYY-MM-DD");
      }

      setValidationDocumentType(getSingleRequest.trRequest.documentTypeID);
      setGlobalDocumentType(getSingleRequest.trRequest.documentTypeID);
      // case Hard Copy
      if (
        getSingleRequest.trRequest.documentTypeID ==
        DocumentType.toId(DocumentType.Hardcopy)
      ) {
        initialValues.area = getSingleRequest.trRequest.area;
        initialValues.address = getSingleRequest.trRequest.detailArea;
      }

      const filteredJustMultiUpload = getSingleRequest.trDocument.filter(
        (item) =>
          item.category !== "Hardcopy SK" &&
          item.category !== "Master Document Realization"
      );
      const transformedData = transformSingleData(filteredJustMultiUpload);
      if (transformedData.length == 2) {
        const newItem: NewIDataUploadItem = {
          title: "Unggah Permohonan Partner / Upload Partner Request",
          fileType: "Partner Request",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        };
        transformedData.push(newItem);
      }

      const filteredSK = getSingleRequest.trDocument.filter(
        (item) => item.category == "Hardcopy SK"
      );
      const transformedDataRealization = transformSingleData(
        getSingleRequest.trDocument.filter(
          (item) => item.category == "Master Document Realization"
        )
      );

      const transformedDataSK = transformSingleData(
        getSingleRequest.trDocument.filter(
          (item) => item.category == "Hardcopy SK"
        )
      );

      if (transformedDataRealization.length > 0) {
        setUploadRealizationDM(transformedDataRealization);
      }
      if (transformedDataSK.length > 0) {
        setUploadSK(transformedDataSK);
      }

      setDataUpload(transformedData);

      if (getSingleRequest.trComment.length > 0) {
        const filteredCommentEnduser = getSingleRequest.trComment.filter(
          (item) => item.toRole === "RL230000002"
        );
        setDataCommentEndUser(filteredCommentEnduser);

        const filteredCommentCL = getSingleRequest.trComment.filter(
          (item) => item.toRole === "RL230000003"
        );
        setDataCommentCL(filteredCommentCL);
      }

      if (getSingleRequest.trRevision.length > 0) {
        setListDataRevision(getSingleRequest.trRevision);
      }

      if (getSingleRequest.trRequest.requestTypeID !== null) {
        initialValues.requestType = getSingleRequest.trRequest.requestTypeID;
        setValidationRequestType(getSingleRequest.trRequest.requestTypeID);
      }

      if (
        getSingleRequest.trRequest.signer == "Tidak ada~Tidak ada#Tidak ada"
      ) {
        initialValues.delegatee = {
          name: "Tidak ada",
          binusianIDEmail: "Tidak ada~Tidak ada",
        };
        initialValues.substitutor = {
          name: "Tidak ada",
          binusianIDEmail: "Tidak ada~Tidak ada",
        };
      }

      if (getSingleRequest.trRequest.delegatee != null) {
        initialValues.delegatee = {
          binusianIDEmail: getSingleRequest.trRequest.delegatee.split("#")[0],
          name: getSingleRequest.trRequest.delegatee.split("#")[1],
        };
      }

      if (getSingleRequest.trRequest.substitutor != null) {
        initialValues.substitutor = {
          binusianIDEmail: getSingleRequest.trRequest.substitutor.split("#")[0],
          name: getSingleRequest.trRequest.substitutor.split("#")[1],
        };
      }
      initialValues.noPowerAttorney = getSingleRequest.trRequest.noPOA;
      initialValues.noSubstitutor = getSingleRequest.trRequest.noSubstitution;
      if (
        ((getSingleRequest.trRequest.requestStatusName ==
          RequestStatus.AwaitingConfirmation &&
          userRevision > 0) ||
          getSingleRequest.trRequest.requestStatusName ==
            RequestStatus.Finished ||
          getSingleRequest.trRequest.requestStatusName ==
            RequestStatus.FinishedRevised ||
          getSingleRequest.trRequest.requestStatusName ==
            RequestStatus.FinishedCanceled ||
          getSingleRequest.trRequest.requestStatusName ==
            RequestStatus.RequestRevise) &&
        getSingleRequest.trRequest.requestTypeID ==
          RequestType.toId(RequestType.DokumenMaster) &&
        id !== undefined
      ) {
        getBase64GeneratePdfSuratPersetujuanMaster(
          id,
          `Surat Persetujuan Penggunaan Master Dokumen_${moment(
            getSingleRequest.finishedDate
          ).format("DDMMYYYY")}.pdf`
        ).then((res) =>
          setFileSuratPersetujuanGeneratePdf((prev) => {
            const data: NewIDataUploadItem = {
              ...prev[0],
              files: [
                {
                  ...prev[0].files[0],
                  documentID: res,
                  fileName: `Surat Persetujuan Penggunaan Master Dokumen_${moment(
                    getSingleRequest.finishedDate
                  ).format("DDMMYYYY")}.pdf`,
                  fileBase64: res,
                },
              ],
            };
            return [data];
          })
        );
      }

      const dbCRR = getSingleRequest.trRequest.noCRR;
      setCrrNumber(dbCRR);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const handleSendBack = (button) => {
    setOpenConfirmation(true);
    setComment("");
    const newDataUploadComment = {
      commentID: "",
      fileBase64: "",
      fileName: "",
    };
    setDataUploadComment(newDataUploadComment);
    setActionButtonClick(button);
  };

  const handleClickSendBack = async (data: NewIDataUploadItem[]) => {
    if (comment != "") {
      setOpenConfirmation(false);
      setLoadingActive(true);
      const insertComment = await sendBack(
        id,
        profile.BinusianId,
        comment,
        data,
        RequestStatus.toId(RequestStatus.SendBack)
      );
      setLoadingActive(false);
      if (insertComment.resultCode === 200) {
        setFeedbackText("Your data has been successfully saved!");
        setFeedbackType("success");
        setOpenFeedback(true);
      } else {
        setFeedbackText("Failed to save data");
        setFeedbackType("failed");
        setOpenFeedback(true);
      }
      setTimeout(() => {
        Navigate("/");
      }, 3000);
    }
  };

  const handleDownloadSuratPersetujuanGeneratePdf = async (
    type,
    dataIndex,
    fileIndex
  ) => {
    const getDataUpload = [...fileSuratPersetujuanGeneratePdf];
    const downloadLink = document.createElement("a");

    const { fileName } = getDataUpload[0].files[fileIndex];
    setLoadingActive(true);
    const getBase64PdfSuratPersetujuan =
      await getBase64GeneratePdfSuratPersetujuanMaster(id, fileName);
    setLoadingActive(false);
    downloadLink.download = fileName;
    downloadLink.href = getBase64PdfSuratPersetujuan;

    downloadLink.click();
  };

  const handleClickRevision = async (data: {
    comment: string;
    data: NewIDataUploadItem[];
  }) => {
    // validasi penjagaan sebelum submit file
    if (
      data.comment.trim() != "" &&
      actionButtonClickRevision == "Not Approve"
    ) {
      setOpenConfirmationRevision(false);
      setOpenConfirmationSubmit(true);
      setTempRevisionData(data);
    } else if (
      (actionButtonClickRevision == "Approve" &&
        data.data[0].files[0]?.fileBase64 == "") ||
      (actionButtonClickRevision == "Approve" &&
        data.data[0].files[0]?.fileBase64 != "" &&
        data.comment.trim() != "")
    ) {
      if (
        formData?.needSK == "true" &&
        formData?.requestType == RequestType.toId(RequestType.DokumenMaster) &&
        actionButtonClickRevision == "Approve"
      ) {
        setOpenConfirmationRevision(false);
        setSaveAndSendConfirmationSubmit(true);
      } else {
        setOpenConfirmationRevision(false);
        setOpenConfirmationSubmit(true);
      }
    }
  };

  const handleSubmitRequestRevision = async () => {
    setOpenConfirmationSubmit(false);
    setOpenConfirmationRevision(false);
    setLoadingActive(true);

    const insertRevision = await requestAndReplyRevision(
      id,
      profile.BinusianId,
      tempRevisionData.comment.trim(),
      tempRevisionData.data,
      RequestStatus.toId(RequestStatus.RequestRevise),
      RoleStatus.toId(RoleStatus.LegalRelation), // role id legal relation
      RoleStatus.toId(RoleStatus.EndUser) // role id end user
    );

    setLoadingActive(false);
  };

  const handleRevisionLegalConfirm = (data: IRevisionLegalComment) => {
    const hasFiles = data.attachments.some((item) =>
      item.files.some((file) => file.fileBase64 !== "" || file.fileName !== "")
    );

    if (data.comment !== "" || !hasFiles) {
      setOpenConfirmationRevisionLegal(false);
      setOpenConfirmationSubmit(true);
      setLegalRevisionData(data);
    }
  };

  useEffect(() => {
    const firstLoad = async () => {
      setLoadingActive(true);
      await getDocumentType();
      await getAreaLocation();
      await getRequestType();
      if (id !== undefined) {
        // get api data
        await getSingleData();
        setValueTab(1);
      }
      setLoadingActive(false);
    };
    firstLoad();
  }, []);

  const validation = (values: IForm) => {
    const errors: FormikErrors<IForm | undefined> = {};

    if (actionButtonClickRevision != "Not Approve") {
      if (values.dateOfPower === "") {
        errors.dateOfPower = "Date of Power of Attorney must be filled";
      }
      if (values.dateGrantOfPower == "") {
        errors.dateGrantOfPower =
          "Grant Date of Power of Attorney must be filled";
      }
      // if (
      //   values.dateGrantOfPower > values.dateOfPower &&
      //   values.grantNote == ""
      // ) {
      //   errors.grantNote = "Note must be filled";
      // }
      if (
        values.startDatePeriod === "" &&
        validationRequestType === RequestType.toId(RequestType.DokumenMaster)
      ) {
        errors.startDatePeriod = "Start Date Period must be filled";
      }
      if (
        values.endDatePeriod === "" &&
        validationRequestType === RequestType.toId(RequestType.DokumenMaster)
      ) {
        errors.endDatePeriod = "End Date Period must be filled";
      }
      if (
        values.startDatePeriod !== "" &&
        values.endDatePeriod !== "" &&
        values.endDatePeriod < values.startDatePeriod &&
        validationRequestType === RequestType.toId(RequestType.DokumenMaster)
      ) {
        errors.endDatePeriod = "End Date must not be earlier than Start Date";
      }
      if (values.titleAgreement === "") {
        errors.titleAgreement = "Title of Agreement must be filled";
      }
      if (
        values.address === "" &&
        values.documentType == DocumentType.toId(DocumentType.Hardcopy)
      ) {
        errors.address = "Address must be filled";
      }
      if (values.counterPart === "") {
        errors.counterPart = "Counterpart must be filled";
      }
      if (values.signer === null) {
        errors.signer = "Signer must be filled";
      }
      if (
        (values.delegatee === null &&
          validationRequestType == RequestType.toId(RequestType.SuratKuasa)) ||
        (values.delegatee === null &&
          validationRequestType ==
            RequestType.toId(RequestType.DokumenMaster) &&
          validationSignerAndLeader == false)
      ) {
        errors.delegatee = "Delegatee must be filled";
      }
      if (
        ((values.noPowerAttorney === "" || values.noPowerAttorney === null) &&
          validationRequestType == RequestType.toId(RequestType.SuratKuasa)) ||
        ((values.noPowerAttorney === "" || values.noPowerAttorney === null) &&
          validationRequestType ==
            RequestType.toId(RequestType.DokumenMaster) &&
          validationSignerAndLeader == false)
      ) {
        errors.noPowerAttorney = "Number of power attorney must be filled";
      }

      if (values.noPowerAttorney?.length > 50) {
        errors.noPowerAttorney =
          "Number of power attorney length must be below 50 characters";
      }

      if (values.noSubstitutor?.length > 50) {
        errors.noSubstitutor =
          "Number of substitution letter length must be below 50 characters";
      }

      const checkFileRequired = dataUpload.some(
        (item) =>
          item.title.includes("*") &&
          item.files.some((file) => file.fileName === "")
      );
      if (checkFileRequired) {
        setErrorUpload("Please upload required file");
      } else {
        setErrorUpload("");
      }

      if (
        uploadSK[0].files.some((file) => file.fileName === "") &&
        (validationRequestType == RequestType.toId(RequestType.SuratKuasa) ||
          (validationRequestType ==
            RequestType.toId(RequestType.DokumenMaster) &&
            validationSignerAndLeader == false))
      ) {
        setErrorUploadSK("Please upload SK file");
      } else {
        setErrorUploadSK("");
      }

      if (
        uploadRealizationDM[0].files.some((file) => file.fileName === "") &&
        validationRequestType == RequestType.toId(RequestType.DokumenMaster) &&
        !validationNeedRealization
      ) {
        setErrorUploadRealizationDM(
          "Please upload Master Document Realization"
        );
      } else {
        setErrorUploadRealizationDM("");
      }
    }

    return errors;
  };

  const onSubmitForm = async (values: IForm) => {
    const updatedValues = { ...values };
    if (
      validationRequestType == RequestType.toId(RequestType.DokumenMaster) &&
      validationSignerAndLeader == true
    ) {
      updatedValues.delegatee = null;
      updatedValues.substitutor = null;
      updatedValues.noPowerAttorney = "";
      updatedValues.noSubstitutor = "";
      if (userRevision > 0) {
        setUpdateStatusIDOnSubmit(
          RequestStatus.toId(RequestStatus.FinishedRevised)
        );
      } else {
        setUpdateStatusIDOnSubmit(RequestStatus.toId(RequestStatus.Finished));
      }
    } else {
      setUpdateStatusIDOnSubmit(RequestStatus.toId(RequestStatus.NeedResponse));
    }
    if (validationDocumentType == DocumentType.toId(DocumentType.Softcopy)) {
      updatedValues.area = "-";
      updatedValues.address = "-";
    }
    if (validationRequestType == RequestType.toId(RequestType.SuratKuasa)) {
      updatedValues.startDatePeriod = "";
      updatedValues.endDatePeriod = "";
      const resetUploadRealizationDM = [
        {
          title:
            "Unggah Realisasi Dokumen Master / Upload Master Document Realization*",
          fileType: "Master Document Realization",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        },
      ];
      setUploadRealizationDM(resetUploadRealizationDM);
    }
    setFormData(updatedValues);

    // if (!enableNoteGrantDate && updatedValues.grantNote != noteGrantDate) {
    //   updatedValues.grantNote = noteGrantDate;
    // }
    // yang || untuk status finish dan ingin ubah data

    if (
      errorUpload != "" ||
      errorUploadRealizationDM != "" ||
      (requestStatusID !=
        RequestStatus.toId(RequestStatus.AwaitingConfirmation) &&
        errorUploadSK != "" &&
        validationDocumentType == DocumentType.toId(DocumentType.Hardcopy)) ||
      crrNumError
    ) {
      setSaveAndSendConfirmationSubmit(false);
      setActionClick("submit");
    } else {
      // Check legal revision first
      if (
        userRevision > 0 &&
        (requestStatusID ===
          RequestStatus.toId(RequestStatus.AwaitingConfirmation) ||
          requestStatusName === RequestStatus.AwaitingConfirmation) &&
        (validationRequestType === RequestType.toId(RequestType.SuratKuasa) ||
          (validationRequestType ===
            RequestType.toId(RequestType.DokumenMaster) &&
            !validationSignerAndLeader)) &&
        validationDocumentType === DocumentType.toId(DocumentType.Softcopy)
      ) {
        tempRevisionData.comment = "";
        setOpenConfirmationRevisionLegal(true);
      }
      // Skip confirmation if legal revision was handled
      else if (!openConfirmationRevisionLegal) {
        if (
          updatedValues.needSK == "true" &&
          updatedValues.requestType ==
            RequestType.toId(RequestType.DokumenMaster) &&
          requestStatusName !== RequestStatus.AwaitingConfirmation
        ) {
          requestStatusName === RequestStatus.RequestRevise
            ? setSaveAndSendConfirmationSubmit(false)
            : setSaveAndSendConfirmationSubmit(true);
          // logic jika surat kuasa tanpa SK (Langsung Confirmation)
        } else {
          // jika requestRevise, open dialog untuk approve / not approve
          requestStatusName == RequestStatus.RequestRevise
            ? setOpenConfirmationRevision(true)
            : setOpenConfirmationSubmit(true);
        }
      }
      setActionClick("submit");
    }
  };

  const handleSave = async (props) => {
    const formikErrors = validation(props.values);
    if (Object.keys(formikErrors).length === 0) {
      const updatedValues = { ...props.values };
      if (
        validationRequestType == RequestType.toId(RequestType.DokumenMaster) &&
        validationSignerAndLeader == true
      ) {
        updatedValues.delegatee = null;
        updatedValues.substitutor = null;
        updatedValues.noPowerAttorney = "";
        updatedValues.noSubstitutor = "";
        if (userRevision > 0) {
          setUpdateStatusIDOnSubmit(
            RequestStatus.toId(RequestStatus.FinishedRevised)
          );
        } else {
          setUpdateStatusIDOnSubmit(RequestStatus.toId(RequestStatus.Finished));
        }
      } else {
        setUpdateStatusIDOnSubmit(
          RequestStatus.toId(RequestStatus.NeedResponse)
        );
      }
      if (validationDocumentType == DocumentType.toId(DocumentType.Softcopy)) {
        updatedValues.area = "-";
        updatedValues.address = "-";
      }
      if (validationRequestType == RequestType.toId(RequestType.SuratKuasa)) {
        updatedValues.startDatePeriod = "";
        updatedValues.endDatePeriod = "";
        const resetUploadRealizationDM = [
          {
            title:
              "Unggah Realisasi Dokumen Master / Upload Master Document Realization*",
            fileType: "Master Document Realization",
            files: [
              { documentID: "", fileBase64: "", fileName: "", folderName: "" },
            ],
          },
        ];
        setUploadRealizationDM(resetUploadRealizationDM);
      }
      setFormData(updatedValues);
      // yang || untuk status finish dan ingin ubah data
      if (
        errorUpload != "" ||
        errorUploadRealizationDM != "" ||
        (requestStatusID !=
          RequestStatus.toId(RequestStatus.AwaitingConfirmation) &&
          errorUploadSK != "" &&
          validationDocumentType == DocumentType.toId(DocumentType.Hardcopy)) ||
        crrNumError
      ) {
        requestStatusName == RequestStatus.RequestRevise
          ? setOpenConfirmationRevision(true)
          : setOpenConfirmationSubmit(false);
        setActionClick("save");
      } else {
        requestStatusName == RequestStatus.RequestRevise
          ? setOpenConfirmationRevision(true)
          : setOpenConfirmationSubmit(true);
        setActionClick("save");
      }
    } else {
      props.setErrors(formikErrors);
    }
  };

  const handleResend = () => {
    if (
      requestTypeId == RequestType.toId(RequestType.DokumenMaster) &&
      (formData?.needSK === "true" || initialValues.needSK === "true")
    ) {
      setResendConfirmationSubmit(true);
    } else {
      setOpenConfirmationResend(true);
      setResendConfirmationValue(
        requestTypeId == RequestType.toId(RequestType.SuratKuasa) ? "SK" : "DM"
      );
    }
  };

  const handleFinalResendConfirm = async () => {
    setOpenConfirmationResend(false);
    setLoadingActive(true);
    const submit = await resendEmailFinishedForm(id, resendConfirmationValue);
    setResendConfirmationSubmit(false);
    setLoadingActive(false);

    if (submit.resultCode === 200) {
      setFeedbackText("Email has been resent successfully!");
      setFeedbackType("success");
      setOpenFeedback(true);
      setTimeout(() => {
        Navigate("/");
      }, 3000);
    } else {
      setFeedbackText(submit.errorMessage);
      setFeedbackType("failed");
      setOpenFeedback(true);
    }
  };

  const handleSaveOrSubmit = async () => {
    setOpenConfirmationRevision(false);
    setOpenConfirmationSubmit(false);
    setLoadingActive(true);
    const newDataUpload = [...dataUpload];
    const dateChoosen = new Date(validationDateOfPower).setHours(0, 0, 0, 0);
    const dateToday = new Date(
      moment(requestDate).format("YYYY-MM-DD")
    ).setHours(0, 0, 0, 0);
    if (dateChoosen >= dateToday) {
      // clear data db if upload single file
      const newItem1 = {
        title: "Approval BU Leader / BU Leader Approval*",
        fileType: "Approval BU Leader",
        files: [
          { documentID: "", fileBase64: "", fileName: "", folderName: "" },
        ],
      };
      newDataUpload.push(newItem1);
      const newItem2 = {
        title: "Unggah Permohonan Partner / Upload Partner Request",
        fileType: "Partner Request",
        files: [
          { documentID: "", fileBase64: "", fileName: "", folderName: "" },
        ],
      };
      newDataUpload.push(newItem2);
    }

    if (actionClick == "submit") {
      // handle save legal revision reply
      if (
        userRevision > 0 &&
        (requestStatusID ===
          RequestStatus.toId(RequestStatus.AwaitingConfirmation) ||
          requestStatusName === RequestStatus.AwaitingConfirmation) &&
        (validationRequestType === RequestType.toId(RequestType.SuratKuasa) ||
          (validationRequestType ===
            RequestType.toId(RequestType.DokumenMaster) &&
            !validationSignerAndLeader)) &&
        validationDocumentType === DocumentType.toId(DocumentType.Softcopy)
      ) {
        await requestAndReplyRevision(
          id,
          profile.BinusianId,
          legalRevisionData.comment.trim(),
          legalRevisionData.attachments,
          RequestStatus.toId(RequestStatus.AwaitingConfirmation),
          RoleStatus.toId(RoleStatus.LegalRelation), // role id legal relation
          RoleStatus.toId(RoleStatus.EndUser) // role id end user
        );
      }

      if (
        requestStatusID ===
        RequestStatus.toId(RequestStatus.AwaitingConfirmation)
      ) {
        const getUploadSK =
          validationDocumentType === DocumentType.toId(DocumentType.Softcopy) ||
          (formData?.requestType ==
            RequestType.toId(RequestType.DokumenMaster) &&
            !formData.needSK)
            ? [
                {
                  title: "Unggah SK / Upload SK*",
                  fileType: "Hardcopy SK",
                  files: [
                    {
                      documentID: "",
                      fileBase64: "",
                      fileName: "",
                      folderName: "",
                    },
                  ],
                },
              ]
            : uploadSK;

        const submit = await editFormLR({
          dataForm: formData,
          dataUpload: newDataUpload,
          uploadRealization: uploadRealizationDM,
          requestID: id,
          requestStatusID:
            validationDocumentType == DocumentType.toId(DocumentType.Softcopy)
              ? userRevision > 0
                ? RequestStatus.toId(RequestStatus.FinishedRevised)
                : RequestStatus.toId(RequestStatus.Finished)
              : updateStatusIDOnSubmit,
          isSend: false,
          crrNumber,
          dataUploadSK: getUploadSK,
        });
        setLoadingActive(false);
        if (submit.resultCode === 200) {
          setFeedbackText("Your data has been successfully saved!");
          setFeedbackType("success");
          setOpenFeedback(true);
          setTimeout(() => {
            Navigate("/");
          }, 3000);
        } else {
          setFeedbackText(submit.errorMessage);
          setFeedbackType("failed");
          setOpenFeedback(true);
        }
      } else {
        const getUploadSK =
          validationDocumentType === DocumentType.toId(DocumentType.Softcopy) ||
          (formData?.requestType ==
            RequestType.toId(RequestType.DokumenMaster) &&
            !formData.needSK)
            ? [
                {
                  title: "Unggah SK / Upload SK*",
                  fileType: "Hardcopy SK",
                  files: [
                    {
                      documentID: "",
                      fileBase64: "",
                      fileName: "",
                      folderName: "",
                    },
                  ],
                },
              ]
            : uploadSK;
        const submit = await editFormLR({
          dataForm: formData,
          dataUpload: newDataUpload,
          uploadRealization: uploadRealizationDM,
          requestID: id,
          requestStatusID:
            validationDocumentType == DocumentType.toId(DocumentType.Softcopy)
              ? userRevision > 0
                ? RequestStatus.toId(RequestStatus.FinishedRevised)
                : RequestStatus.toId(RequestStatus.Finished)
              : updateStatusIDOnSubmit,
          dataUploadSK: getUploadSK,
          isSend: true,
          crrNumber,
          emailType:
            saveAndSendConfirmationValue !== ""
              ? saveAndSendConfirmationValue
              : formData?.requestType ==
                RequestType.toId(RequestType.SuratKuasa)
              ? "SK"
              : "DM",
          noteRequestRevise: tempRevisionData.comment.trim(),
        });
        setLoadingActive(false);
        if (submit.resultCode === 200) {
          setFeedbackText("Your data has been successfully saved!");
          setFeedbackType("success");
          setOpenFeedback(true);
          setTimeout(() => {
            Navigate("/");
          }, 3000);
        } else {
          setFeedbackText(submit.errorMessage);
          setFeedbackType("failed");
          setOpenFeedback(true);
        }
      }
    } else {
      const getUploadSK =
        validationDocumentType === DocumentType.toId(DocumentType.Softcopy) ||
        (formData?.requestType == RequestType.toId(RequestType.DokumenMaster) &&
          formData.needSK == "false")
          ? [
              {
                title: "Unggah SK / Upload SK*",
                fileType: "Hardcopy SK",
                files: [
                  {
                    documentID: "",
                    fileBase64: "",
                    fileName: "",
                    folderName: "",
                  },
                ],
              },
            ]
          : uploadSK;
      const save = await editFormLR({
        dataForm: formData,
        dataUpload: newDataUpload,
        uploadRealization: uploadRealizationDM,
        requestID: id,
        requestStatusID:
          validationDocumentType == DocumentType.toId(DocumentType.Softcopy)
            ? userRevision > 0
              ? RequestStatus.toId(RequestStatus.FinishedRevised)
              : RequestStatus.toId(RequestStatus.Finished)
            : updateStatusIDOnSubmit,
        dataUploadSK: getUploadSK,
        isSend: false,
        crrNumber,
        noteRequestRevise: tempRevisionData.comment.trim(),
      });
      setLoadingActive(false);
      if (save.resultCode === 200) {
        setFeedbackText("Your data has been successfully saved!");
        setFeedbackType("success");
        setOpenFeedback(true);
        setTimeout(() => {
          Navigate("/");
        }, 3000);
      } else {
        setFeedbackText(save.errorMessage);
        setFeedbackType("failed");
        setOpenFeedback(true);
      }
    }
  };

  const onResetForm = () => {
    setValidationDocumentType(globalDocumentType);
  };

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleChangeUpload = async (
    type,
    data,
    dataIndex,
    fileIndex,
    singleFileCategory
  ) => {
    if (data != undefined) {
      if (data.name.length > 150) {
        setFeedbackText("File name cannot be more than 150 letters!");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
        return;
      }
      const resultBase64File: any = await getBase64(data).then(
        (bs64: any) => bs64
      );

      const newFileNameWithoutDate = RemoveDateFromFileName(data.name);

      if (type == "multi") {
        // multi untuk upload data yg looping, kalo single untuk upload file satuan
        const newDataUpload = [...dataUpload];
        const filteredSameFileName = !newDataUpload.some((item) =>
          item.files.some((file) => {
            const existingFileNameWithoutDate = RemoveDateFromFileName(
              file.fileName
            );
            return existingFileNameWithoutDate === newFileNameWithoutDate;
          })
        );
        if (filteredSameFileName) {
          newDataUpload[dataIndex] = {
            title: newDataUpload[dataIndex].title,
            fileType: newDataUpload[dataIndex].fileType,
            files: [...newDataUpload[dataIndex].files],
          };
          newDataUpload[dataIndex].files[fileIndex] = {
            documentID: "",
            fileBase64: resultBase64File,
            fileName: data.name,
            folderName: "",
          };
          setDataUpload(newDataUpload);
          if (
            newDataUpload[dataIndex].title.includes("*") &&
            newDataUpload[dataIndex].files[fileIndex].fileBase64 != ""
          ) {
            setErrorUpload("");
          }
        } else {
          setFeedbackText(
            "The file already exists, please change the file name"
          );
          setFeedbackType("failed");
          setOpenFeedback(true);
          setTimeout(() => {
            setOpenFeedback(false);
          }, 2000);
        }
      } else {
        switch (singleFileCategory) {
          case "Hardcopy SK": {
            const filteredSameName = !uploadSK[0].files.some((file) => {
              const existingFileNameWithoutDate = RemoveDateFromFileName(
                file.fileName
              );
              return existingFileNameWithoutDate === newFileNameWithoutDate;
            });
            if (filteredSameName) {
              const newUploadSK: NewIDataUploadItem = {
                title: uploadSK[0].title,
                fileType: uploadSK[0].fileType,
                files: [...uploadSK[0].files],
              };
              newUploadSK.files[fileIndex] = {
                documentID: "",
                fileBase64: resultBase64File,
                fileName: data.name,
                folderName: "",
              };
              setUploadSK([newUploadSK]);
              setErrorUploadSK("");
            } else {
              setFeedbackText(
                "The file already exists, please change the file name"
              );
              setFeedbackType("failed");
              setOpenFeedback(true);
              setTimeout(() => {
                setOpenFeedback(false);
              }, 2000);
            }
            break;
          }
          case "Master Document Realization": {
            const filteredSameName = !uploadRealizationDM[0].files.some(
              (file) => {
                const existingFileNameWithoutDate = RemoveDateFromFileName(
                  file.fileName
                );
                return existingFileNameWithoutDate === newFileNameWithoutDate;
              }
            );
            if (filteredSameName) {
              const newUploadRealizationDM: NewIDataUploadItem = {
                title: uploadRealizationDM[0].title,
                fileType: uploadRealizationDM[0].fileType,
                files: [...uploadRealizationDM[0].files],
              };
              newUploadRealizationDM.files[fileIndex] = {
                documentID: "",
                fileBase64: resultBase64File,
                fileName: data.name,
                folderName: "",
              };
              setUploadRealizationDM([newUploadRealizationDM]);
              setErrorUploadRealizationDM("");
            } else {
              setFeedbackText(
                "The file already exists, please change the file name"
              );
              setFeedbackType("failed");
              setOpenFeedback(true);
              setTimeout(() => {
                setOpenFeedback(false);
              }, 2000);
            }
            break;
          }
        }
      }
    }
  };

  const handleChangeDelete = (
    type,
    dataIndex,
    fileIndex,
    singleFileCategory
  ) => {
    if (type == "multi") {
      // multi untuk upload data yg looping, kalo single untuk upload file satuan
      const newDataUpload = [...dataUpload];
      newDataUpload[dataIndex].files[fileIndex] = {
        documentID: "",
        fileBase64: "",
        fileName: "",
        folderName: "",
      };
      setDataUpload(newDataUpload);
      if (
        newDataUpload[dataIndex].title.includes("*") &&
        newDataUpload[dataIndex].files[fileIndex].fileBase64 == ""
      ) {
        setErrorUpload("Please upload required file");
      }
    } else {
      switch (singleFileCategory) {
        case "Hardcopy SK": {
          const newUploadSK = uploadSK;
          newUploadSK[0].files[fileIndex] = {
            documentID: "",
            fileBase64: "",
            fileName: "",
            folderName: "",
          };
          setUploadSK(newUploadSK);
          setErrorUploadSK("Please upload hardcopy SK");
          break;
        }
        case "Master Document Realization": {
          const newUploadRealizationDM = uploadRealizationDM;
          newUploadRealizationDM[0].files[fileIndex] = {
            documentID: "",
            fileBase64: "",
            fileName: "",
            folderName: "",
          };
          setUploadRealizationDM(newUploadRealizationDM);
          setErrorUploadRealizationDM(
            "Please upload Master Document Realization"
          );
          break;
        }
      }
    }
  };

  const handleChangeDownload = async (
    type,
    dataIndex,
    fileIndex,
    singleFileCategory
  ) => {
    const getDataUpload = [...dataUpload];
    const downloadLink = document.createElement("a");

    // eslint-disable-next-line unicorn/consistent-function-scoping, consistent-return
    const downloadFile = async () => {
      try {
        // get all data for table list User
        const currentTime: any = new Date();
        const differenceInMinutesTokenSharepoint: any =
          (sharepoint.expToken - currentTime) / 1000 / 60;

        if (differenceInMinutesTokenSharepoint < 10) {
          const tokenSharepoint = await getSharepointToken();
          setSharepoint({
            ...sharepoint,
            token: tokenSharepoint.token,
            expToken: new Date(currentTime.getTime() + 30 * 60 * 1000),
          });
          // lakukan download
          if (type == "multi") {
            const getBase64Download = await downloadSingleFile(
              getDataUpload[dataIndex].files[fileIndex].fileName,
              getDataUpload[dataIndex].fileType,
              id,
              tokenSharepoint.token
            );
            return getBase64Download;
          }
          switch (singleFileCategory) {
            case "Hardcopy SK": {
              const getBase64Download = await downloadSingleFile(
                uploadSK[0].files[fileIndex].fileName,
                uploadSK[0].fileType,
                id,
                tokenSharepoint.token
              );
              return getBase64Download;
            }
            case "Master Document Realization": {
              const getBase64Download = await downloadSingleFile(
                uploadRealizationDM[0].files[fileIndex].fileName,
                uploadRealizationDM[0].fileType,
                id,
                tokenSharepoint.token
              );
              return getBase64Download;
            }
          }
        }
        // eslint-disable-next-line no-else-return
        else {
          if (type == "multi") {
            const getBase64Download = await downloadSingleFile(
              getDataUpload[dataIndex].files[fileIndex].fileName,
              getDataUpload[dataIndex].fileType,
              id,
              sharepoint.token
            );
            return getBase64Download;
          }
          switch (singleFileCategory) {
            case "Hardcopy SK": {
              const getBase64Download = await downloadSingleFile(
                uploadSK[0].files[fileIndex].fileName,
                uploadSK[0].fileType,
                id,
                sharepoint.token
              );
              return getBase64Download;
            }
            case "Master Document Realization": {
              const getBase64Download = await downloadSingleFile(
                uploadRealizationDM[0].files[fileIndex].fileName,
                uploadRealizationDM[0].fileType,
                id,
                sharepoint.token
              );
              return getBase64Download;
            }
          }
        }
      } catch (error) {
        // Handle error if needed
        console.log("Error fetching data:", error);
      }
    };

    setLoadingActive(true);
    const tempBase64File = await downloadFile();
    setLoadingActive(false);
    if (type == "multi") {
      if (getDataUpload[dataIndex].files[fileIndex].documentID != "") {
        getDataUpload[dataIndex].files[fileIndex].fileBase64 = tempBase64File;
      }
      if (getDataUpload[dataIndex].files[fileIndex].fileBase64 != "") {
        downloadLink.href =
          getDataUpload[dataIndex].files[fileIndex].fileBase64;
        downloadLink.download =
          getDataUpload[dataIndex].files[fileIndex].fileName;
        downloadLink.click();
      }
    } else {
      switch (singleFileCategory) {
        case "Hardcopy SK": {
          if (uploadSK[0].files[fileIndex].documentID != "") {
            uploadSK[0].files[fileIndex].fileBase64 = tempBase64File;
          }
          if (uploadSK[0].files[fileIndex].fileBase64 != "") {
            downloadLink.href = uploadSK[0].files[fileIndex].fileBase64;
            downloadLink.download = uploadSK[0].files[fileIndex].fileName;
            downloadLink.click();
          }
          break;
        }
        case "Master Document Realization": {
          if (uploadRealizationDM[0].files[fileIndex].documentID != "") {
            uploadRealizationDM[0].files[fileIndex].fileBase64 = tempBase64File;
          }
          if (uploadRealizationDM[0].files[fileIndex].fileBase64 != "") {
            downloadLink.href =
              uploadRealizationDM[0].files[fileIndex].fileBase64;
            downloadLink.download =
              uploadRealizationDM[0].files[fileIndex].fileName;
            downloadLink.click();
          }
          break;
        }
      }
    }
  };

  const handleChangeDateOfPower = (date) => {
    const dateChoosen = new Date(date).setHours(0, 0, 0, 0);
    const dateToday = new Date(
      moment(requestDate).format("YYYY-MM-DD")
    ).setHours(0, 0, 0, 0);
    const dateGrantPOA = new Date(validationDateGrantOfPower).setHours(
      0,
      0,
      0,
      0
    );

    if (dateChoosen < dateToday && dataUpload.length == 1) {
      setDataUpload((prev) => [
        ...prev,
        {
          title: "Approval BU Leader / BU Leader Approval*",
          fileType: "Approval BU Leader",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        },
        {
          title: "Unggah Permohonan Partner / Upload Partner Request",
          fileType: "Partner Request",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        },
      ]);
    }

    if (dateChoosen >= dateToday && dataUpload.length > 1) {
      setDataUpload((prev) => [prev[0]]);
    }

    setErrorUpload("");
    // if (dateGrantPOA <= dateChoosen) {
    //   setEnableNoteGrantDate(false);
    // } else {
    //   setEnableNoteGrantDate(true);
    // }
  };

  // const handleChangeGrantDateOfPower = (date) => {
  //   setValidationDateGrantOfPower(date);
  //   const dateChoosen = new Date(date).setHours(0, 0, 0, 0);
  //   const datePOA = new Date(validationDateOfPower).setHours(0, 0, 0, 0);
  //   if (dateChoosen <= datePOA) {
  //     setEnableNoteGrantDate(false);
  //   } else {
  //     setEnableNoteGrantDate(true);
  //   }
  // };

  const handleCRRChange = (value: string, error?: string) => {
    setCrrNumber(value);
    setCrrError(error || "");
  };

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px", padding: 0, margin: 0 }}>
        <div className="tabs-container">
          Home {">"} {requestStatusName}
        </div>
        <div className="tabs-container">
          <hr style={{ color: "black", width: "100%" }} />
        </div>
      </Box>
      <Grid item lg={12} md={12} xs={12}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ marginLeft: "23px", width: "300px" }}
          >
            <b>
              No. Request / <i>Request Number</i>
            </b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "15px" }}
          >
            <b>:</b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "250px" }}
          >
            <b>{requestNumber}</b>
          </Typography>
        </div>
      </Grid>
      <Grid item lg={12} md={12} xs={12}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ marginLeft: "23px", width: "300px" }}
          >
            <b>
              Tanggal Permintaan / <i>Request Date</i>
            </b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "15px" }}
          >
            <b>:</b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "200px" }}
          >
            <b>{requestDate}</b>
          </Typography>
        </div>
      </Grid>
      <CRRNumberField
        crrNumber={crrNumber}
        crrNumError={crrNumError}
        onCRRChange={handleCRRChange}
      />
      <div className="tabs-container" style={{ marginTop: "1.5%" }}>
        <Tabs value={valueTab} onChange={handleChangeTab} textColor="primary">
          <Tab
            style={{ color: valueTab === 0 ? "#fff" : "#000" }}
            color="primary"
            label="Data Diri / Profile"
            className={valueTab === 0 ? "active-tab-panel" : "hidden-tab-panel"}
          />

          <Tab
            style={{ color: valueTab === 1 ? "#fff" : "#000" }}
            color="primary"
            label="Permohonan Detil / Detail Request"
            className={valueTab === 1 ? "active-tab-panel" : "hidden-tab-panel"}
          />

          <Tab
            style={{ color: valueTab === 2 ? "#fff" : "#000" }}
            color="primary"
            label="Workflow"
            className={valueTab === 2 ? "active-tab-panel" : "hidden-tab-panel"}
          />
        </Tabs>
      </div>
      <div className="tabs-container">
        <hr className="tab-line" />
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmitForm}
        validate={validation}
        onReset={onResetForm}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit} onReset={props.handleReset}>
            <TabPanel value={valueTab} index={0}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Pemohon / <i>Applicant</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="binusianName"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jabatan / <i>Title</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent propsData={props} name="title" />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Divisi / <i>Business Unit</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="businessUnit"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "25px" }}
                    gutterBottom
                  >
                    <u>Business Unit Leader</u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="buLeader"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Department / <i>Department</i>
                    </u>
                  </Typography>
                  <TextFieldMultiDisabledComponent
                    propsData={props}
                    name="department"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "40px" }}
                    gutterBottom
                  >
                    <u>
                      Ekstensi / <i>Extension</i> (Ext.)
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="extension"
                  />
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(1)}
                >
                  Next Page {">>"}
                </Button>
              </Box>
            </TabPanel>
            <TabPanel value={valueTab} index={1}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Tanggal Surat Kuasa / <i>Date of Power of Attorney</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDateValidationComponent
                    propsData={props}
                    name="dateOfPower"
                    onChildDataChange={(dataChild) =>
                      handleChangeDateOfPower(dataChild)
                    }
                  />
                  {props.errors.dateOfPower && (
                    <div className="error-message">
                      {props.errors.dateOfPower}
                    </div>
                  )}

                  <Typography
                    variant="subtitle1"
                    style={{
                      paddingTop: "20px",
                    }}
                    gutterBottom
                  >
                    <u>
                      Pihak Penandatangan / <i>Signer</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <AutocompleteComponent
                    propsData={props}
                    name="signer"
                    optional
                  />
                  {props.errors.signer && (
                    <div className="error-message">{props.errors.signer}</div>
                  )}
                </Grid>

                <Grid item lg={6} md={12} xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontSize: "0.98rem" }}
                    gutterBottom
                  >
                    <u>
                      Tanggal Pemberian Surat Kuasa /{" "}
                      <i>Date of Granting of Power of Attorney</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDateComponent
                    propsData={props}
                    name="dateGrantOfPower"
                  />
                  {props.errors.dateGrantOfPower && (
                    <div className="error-message">
                      {props.errors.dateGrantOfPower}
                    </div>
                  )}

                  <Typography
                    variant="subtitle1"
                    style={{
                      paddingTop: "20px",
                    }}
                    gutterBottom
                  >
                    <u>
                      Catatan Legal / <i>Legal Notes</i>
                    </u>
                  </Typography>
                  <Grid item lg={12} md={12} xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Corporate Legal:
                    </Typography>
                    <TextAreaComponent propsData={props} name="clNote" />
                  </Grid>
                  <Grid item lg={12} md={12} xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Legal Relation:
                    </Typography>
                    <TextAreaComponent propsData={props} name="lrNote" />
                  </Grid>
                </Grid>

                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Judul Perjanjian / <i>Title of Agreement</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldMultiComponent
                    propsData={props}
                    name="titleAgreement"
                  />
                  {props.errors.titleAgreement && (
                    <div className="error-message">
                      {props.errors.titleAgreement}
                    </div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Partner / <i>Counterpart</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldComponent propsData={props} name="counterPart" />
                  {props.errors.counterPart && (
                    <div className="error-message">
                      {props.errors.counterPart}
                    </div>
                  )}
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "20px" }}
                    gutterBottom
                  >
                    <u>
                      Jenis Dokumen / <i>Document Type</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistComponentValidation
                    propsData={props}
                    onChildDataChange={(dataChild) =>
                      setValidationDocumentType(dataChild)
                    }
                    name="documentType"
                    ddlData={listDocumentType}
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {dataUpload.map((obj, i) => (
                    <div>
                      <UploadMultipleFileComponent
                        file={obj}
                        fileIndex={i}
                        onUploadFile={(data, fileIndex) => {
                          handleChangeUpload("multi", data, i, fileIndex, null);
                        }}
                        onDeleteFile={(fileIndex) =>
                          handleChangeDelete("multi", i, fileIndex, null)
                        }
                        onAddMoreData={() => {
                          if (dataUpload[i].files.length < 5) {
                            setDataUpload((prevState) => {
                              const newState = [...prevState];
                              const emptyFile = {
                                documentID: "",
                                fileBase64: "",
                                fileName: "",
                                folderName: "",
                              };
                              if (i >= 0 && i < newState.length) {
                                newState[i].files.push(emptyFile);
                              }

                              return newState;
                            });
                          }
                        }}
                        onDeleteData={(ind) => {
                          setDataUpload((prevState) => {
                            const newState = [...prevState];
                            if (
                              i >= 0 &&
                              i < newState.length &&
                              ind >= 0 &&
                              ind < newState[i].files.length
                            ) {
                              newState[i].files.splice(ind, 1);
                            }

                            return newState;
                          });
                        }}
                        onDownloadFile={(fileIndex) => {
                          handleChangeDownload("multi", i, fileIndex, null);
                        }}
                        requiredValidationMessage={errorUpload}
                      />
                    </div>
                  ))}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {validationDocumentType ==
                    DocumentType.toId(DocumentType.Hardcopy) && (
                    <div style={{ paddingBottom: "20px" }}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Lokasi / <i>Area</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <DropdownlistComponent
                        propsData={props}
                        name="area"
                        ddlData={listAreaLocation}
                      />
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingTop: "20px" }}
                      >
                        <u>
                          Ruang / <i>Room</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldMultiComponent
                        propsData={props}
                        name="address"
                      />
                      {props.errors.address && (
                        <div className="error-message">
                          {props.errors.address}
                        </div>
                      )}
                    </div>
                  )}
                  {validationRequestType ==
                    RequestType.toId(RequestType.DokumenMaster) && (
                    <>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Periode Penggunaan (Khusus Dokumen Master) /{" "}
                          <i>Period of Use (Master Document only)</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <Grid container spacing={3} item md={12} xs={12}>
                        <Grid item md={6} xs={6}>
                          <TextFieldDateComponent
                            propsData={props}
                            name="startDatePeriod"
                          />
                          {props.errors.startDatePeriod && (
                            <div className="error-message">
                              {props.errors.startDatePeriod}
                            </div>
                          )}
                        </Grid>
                        <Grid item md={6} xs={6}>
                          <TextFieldDateComponent
                            propsData={props}
                            name="endDatePeriod"
                          />
                          {props.errors.endDatePeriod && (
                            <div className="error-message">
                              {props.errors.endDatePeriod}
                            </div>
                          )}
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jenis Permohonan / <i> Request Type</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistComponentValidation
                    propsData={props}
                    name="requestType"
                    onChildDataChange={(dataChild) =>
                      setValidationRequestType(dataChild)
                    }
                    ddlData={listRequestType}
                  />
                  {props.values.requestType ==
                    RequestType.toId(RequestType.DokumenMaster) && (
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column",
                      }}
                    >
                      <Box component="form" style={{ paddingLeft: "1rem" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e) => {
                                props.handleChange({
                                  target: {
                                    name: "needSK",
                                    value: e.target.checked ? "true" : "false",
                                  },
                                });
                                setValidationSignerAndLeader(
                                  props.values.needSK == "true"
                                );
                              }}
                              checked={props.values.needSK == "true"}
                              name="needSK"
                            />
                          }
                          label={
                            <Typography variant="subtitle1">
                              Butuh SK / <i>Need SK</i>
                            </Typography>
                          }
                        />
                      </Box>
                      <Box component="form" style={{ paddingLeft: "1rem" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e) => {
                                props.handleChange({
                                  target: {
                                    name: "needRealization",
                                    value: e.target.checked ? "true" : "false",
                                  },
                                });
                                setValidationNeedRealization(
                                  props.values.needRealization == "true"
                                );
                              }}
                              checked={props.values.needRealization == "true"}
                              name="needRealization"
                            />
                          }
                          label={
                            <Typography variant="subtitle1">
                              Butuh Realisasi Dokumen /{" "}
                              <i>Need Document Realization</i>
                            </Typography>
                          }
                        />
                      </Box>
                    </Box>
                  )}
                </Grid>
                {validationRequestType ==
                RequestType.toId(RequestType.DokumenMaster) ? (
                  <Grid item lg={6} md={12} xs={12}>
                    {validationNeedRealization == false &&
                      uploadRealizationDM.map((obj, i) => (
                        <div>
                          <UploadMultipleFileComponent
                            file={obj}
                            fileIndex={i}
                            onUploadFile={(data, fileIndex) => {
                              handleChangeUpload(
                                "single",
                                data,
                                i,
                                fileIndex,
                                "Master Document Realization"
                              );
                            }}
                            onDeleteFile={(fileIndex) =>
                              handleChangeDelete(
                                "single",
                                i,
                                fileIndex,
                                "Master Document Realization"
                              )
                            }
                            onAddMoreData={() => {
                              if (uploadRealizationDM[i].files.length < 5) {
                                setUploadRealizationDM((prevState) => {
                                  const newState = [...prevState];
                                  const emptyFile = {
                                    documentID: "",
                                    fileBase64: "",
                                    fileName: "",
                                    folderName: "",
                                  };
                                  if (i >= 0 && i < newState.length) {
                                    newState[i].files.push(emptyFile);
                                  }

                                  return newState;
                                });
                              }
                            }}
                            onDeleteData={(ind) => {
                              setUploadRealizationDM((prevState) => {
                                const newState = [...prevState];
                                if (
                                  i >= 0 &&
                                  i < newState.length &&
                                  ind >= 0 &&
                                  ind < newState[i].files.length
                                ) {
                                  newState[i].files.splice(ind, 1);
                                }

                                return newState;
                              });
                            }}
                            onDownloadFile={(fileIndex) => {
                              handleChangeDownload(
                                "single",
                                i,
                                fileIndex,
                                "Master Document Realization"
                              );
                            }}
                            requiredValidationMessage={errorUploadRealizationDM}
                          />
                        </div>
                      ))}

                    {((requestStatusName ==
                      RequestStatus.AwaitingConfirmation &&
                      userRevision > 0) ||
                      requestStatusName == RequestStatus.Finished ||
                      requestStatusName == RequestStatus.FinishedRevised ||
                      requestStatusName == RequestStatus.FinishedCanceled ||
                      requestStatusName == RequestStatus.RequestRevise) &&
                      requestTypeId ==
                        RequestType.toId(RequestType.DokumenMaster) && (
                        <>
                          {fileSuratPersetujuanGeneratePdf.map(
                            (obj, i) =>
                              obj.files[0].fileName != "" && (
                                <div
                                  style={{
                                    marginTop: validationNeedRealization
                                      ? "2rem"
                                      : "0rem",
                                  }}
                                >
                                  <UploadMultipleFileComponent
                                    disabled
                                    file={obj}
                                    fileIndex={i}
                                    onUploadFile={() => {}}
                                    onDeleteFile={() => {}}
                                    onAddMoreData={() => {}}
                                    onDeleteData={() => {}}
                                    onDownloadFile={(fileIndex) => {
                                      handleDownloadSuratPersetujuanGeneratePdf(
                                        "single",
                                        i,
                                        fileIndex
                                      );
                                    }}
                                    requiredValidationMessage=""
                                  />
                                </div>
                              )
                          )}
                        </>
                      )}
                  </Grid>
                ) : (
                  <Grid item lg={6} md={12} xs={12} />
                )}
                {(validationRequestType ==
                  RequestType.toId(RequestType.SuratKuasa) ||
                  (validationRequestType ==
                    RequestType.toId(RequestType.DokumenMaster) &&
                    validationSignerAndLeader == false)) && (
                  <>
                    <Grid item lg={6} md={12} xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Penerima Kuasa / <i> Delegatee</i>
                        </u>
                      </Typography>
                      <AutocompleteComponent
                        propsData={props}
                        name="delegatee"
                        optional
                      />
                      {props.errors.delegatee && (
                        <div className="error-message">
                          {props.errors.delegatee}
                        </div>
                      )}
                    </Grid>
                    <Grid item lg={6} md={12} xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Subtitusi / <i> Substitutor</i>
                        </u>
                      </Typography>
                      <AutocompleteComponent
                        propsData={props}
                        name="substitutor"
                        optional
                      />
                      {props.errors.substitutor && (
                        <div className="error-message">
                          {props.errors.substitutor}
                        </div>
                      )}
                    </Grid>
                    <Grid item lg={6} md={12} xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          No. Surat Kuasa / <i> Number of Power of Attorney</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldComponent
                        propsData={props}
                        name="noPowerAttorney"
                      />
                      {props.errors.noPowerAttorney && (
                        <div className="error-message">
                          {props.errors.noPowerAttorney}
                        </div>
                      )}
                    </Grid>
                    <Grid item lg={6} md={12} xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          No. Surat Substitusi /{" "}
                          <i> Number of Substitution Letter</i>
                        </u>
                      </Typography>
                      <TextFieldComponent
                        propsData={props}
                        name="noSubstitutor"
                      />
                      {props.errors.noSubstitutor && (
                        <div className="error-message">
                          {props.errors.noSubstitutor}
                        </div>
                      )}
                    </Grid>
                  </>
                )}
                {requestStatusID !=
                  RequestStatus.toId(RequestStatus.AwaitingConfirmation) &&
                  validationDocumentType ==
                    DocumentType.toId(DocumentType.Hardcopy) &&
                  (validationRequestType ==
                    RequestType.toId(RequestType.SuratKuasa) ||
                    (validationRequestType ==
                      RequestType.toId(RequestType.DokumenMaster) &&
                      validationSignerAndLeader == false)) && (
                    <Grid item lg={6} md={12} xs={12}>
                      {uploadSK.map((obj, i) => (
                        <div>
                          <UploadMultipleFileComponent
                            file={obj}
                            fileIndex={i}
                            onUploadFile={(data, fileIndex) => {
                              handleChangeUpload(
                                "single",
                                data,
                                i,
                                fileIndex,
                                "Hardcopy SK"
                              );
                            }}
                            onDeleteFile={(fileIndex) =>
                              handleChangeDelete(
                                "single",
                                i,
                                fileIndex,
                                "Hardcopy SK"
                              )
                            }
                            onAddMoreData={() => {
                              if (uploadSK[i].files.length < 5) {
                                setUploadSK((prevState) => {
                                  const newState = [...prevState];
                                  const emptyFile = {
                                    documentID: "",
                                    fileBase64: "",
                                    fileName: "",
                                    folderName: "",
                                  };
                                  if (i >= 0 && i < newState.length) {
                                    newState[i].files.push(emptyFile);
                                  }

                                  return newState;
                                });
                              }
                            }}
                            onDeleteData={(ind) => {
                              setUploadSK((prevState) => {
                                const newState = [...prevState];
                                if (
                                  i >= 0 &&
                                  i < newState.length &&
                                  ind >= 0 &&
                                  ind < newState[i].files.length
                                ) {
                                  newState[i].files.splice(ind, 1);
                                }

                                return newState;
                              });
                            }}
                            onDownloadFile={(fileIndex) => {
                              handleChangeDownload(
                                "single",
                                i,
                                fileIndex,
                                "Hardcopy SK"
                              );
                            }}
                            requiredValidationMessage={errorUploadSK}
                          />
                        </div>
                      ))}
                    </Grid>
                  )}
              </Grid>

              {requestStatusID ==
              RequestStatus.toId(RequestStatus.AwaitingConfirmation) ? (
                <Grid container justifyContent="center" sx={{ mt: 2 }}>
                  <Button
                    variant="outlined"
                    sx={{
                      m: 1,
                      width: "150px",
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                    onClick={() => handleSendBack("Send back")}
                  >
                    Send Back
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      m: 1,
                      width: "150px",
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                    type="submit"
                  >
                    Approve
                  </Button>
                </Grid>
              ) : (
                <Grid container justifyContent="center" sx={{ mt: 2 }}>
                  {/* buat ternaryy lagi cek jika request Revise */}
                  {requestStatusName == RequestStatus.RequestRevise ? (
                    <>
                      <Button
                        variant="outlined"
                        sx={{
                          m: 1,
                          width: "150px",
                          textTransform: "none",
                          fontWeight: "bold",
                        }}
                        onClick={() => {
                          setActionButtonClickRevision("Not Approve");
                          setOpenConfirmationRevision(true);
                          handleSave(props);
                        }}
                      >
                        Not Approve
                      </Button>
                      <Button
                        variant="contained"
                        sx={{
                          m: 1,
                          width: "150px",
                          textTransform: "none",
                          fontWeight: "bold",
                        }}
                        onClick={() => {
                          setActionButtonClickRevision("Approve");
                          setOpenConfirmationRevision(true);
                        }}
                        type="submit"
                      >
                        Approve
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        sx={{
                          m: 1,
                          width: "150px",
                          textTransform: "none",
                          fontWeight: "bold",
                        }}
                        onClick={() => handleSave(props)}
                      >
                        Save
                      </Button>
                      <Button
                        variant="contained"
                        sx={{
                          m: 1,
                          width: "150px",
                          textTransform: "none",
                          fontWeight: "bold",
                        }}
                        type="submit"
                      >
                        Save & Send
                      </Button>
                      {(requestStatusName === RequestStatus.Finished ||
                        requestStatusName === RequestStatus.FinishedRevised ||
                        requestStatusName ===
                          RequestStatus.FinishedCanceled) && (
                        <Button
                          variant="contained"
                          sx={{
                            m: 1,
                            width: "150px",
                            textTransform: "none",
                            fontWeight: "bold",
                          }}
                          onClick={handleResend}
                        >
                          Resend
                        </Button>
                      )}
                    </>
                  )}
                </Grid>
              )}

              {listDataRevision.length > 0 && (
                <>
                  <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                    Permintaan Revisi / <i>Request Revise from Requestor</i>
                    <hr />
                  </Box>
                  {listDataRevision.map((obj, i) => (
                    <RevisionDisabledComponent
                      allObj={{ ...obj, requestNumber }}
                    />
                  ))}
                </>
              )}

              {dataCommentEndUser.length > 0 && (
                <>
                  <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                    Komentar / <i>Comments for Requestor</i>
                    <hr />
                  </Box>
                  {dataCommentEndUser.map((obj, i) => (
                    <CommentDisabledComponent
                      allObj={{ ...obj, requestNumber }}
                      key={obj.commentID}
                    />
                  ))}
                </>
              )}

              {dataCommentCL.length > 0 && (
                <>
                  <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                    Komentar / <i>Comments for Corporate Legal</i>
                    <hr />
                  </Box>
                  {dataCommentCL.map((obj, i) => (
                    <CommentDisabledComponent
                      allObj={{ ...obj, requestNumber }}
                      key={obj.commentID}
                    />
                  ))}
                </>
              )}

              <Box
                sx={{
                  display: "flex",
                  paddingTop: "20px",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(0)}
                >
                  {"<<"} Previous Page
                </Button>
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(2)}
                >
                  {">>"} Next Page
                </Button>
              </Box>

              <ConfirmationDialogComment
                open={openConfirmation}
                commentChildToParent={(e) => setComment(e)}
                commentParentToChild={comment}
                onConfirm={(e) => {
                  handleClickSendBack(e);
                }}
                onCancel={() => {
                  setOpenConfirmation(false);
                }}
                action={actionButtonClick}
              />

              <ConfirmationDialog
                open={openConfirmationSubmit}
                title="Confirmation"
                message="Are you sure you want to proceed ?"
                onConfirm={async () => {
                  if (
                    actionButtonClickRevision == "Approve" ||
                    actionButtonClickRevision == "Not Approve"
                  ) {
                    setOpenConfirmationRevision(false);
                    await handleSubmitRequestRevision();
                  }
                  await handleSaveOrSubmit();
                }}
                onCancel={() => {
                  setOpenConfirmationSubmit(false);
                }}
              />

              <ConfirmationDialog
                open={openConfirmationResend}
                title="Confirmation"
                message="Are you sure you want to proceed ?"
                onConfirm={async () => {
                  await handleFinalResendConfirm();
                }}
                onCancel={() => {
                  setOpenConfirmationResend(false);
                }}
              />

              <ConfirmationDialogRevisionUser
                open={openConfirmationRevision}
                onConfirm={(e) => {
                  handleClickRevision(e);
                }}
                onCancel={() => {
                  setOpenConfirmationRevision(false);
                }}
                isMandatory={actionButtonClickRevision !== "Approve"}
                action={actionButtonClickRevision}
              />

              <ConfirmationDialogRevisionLegal
                open={openConfirmationRevisionLegal}
                onConfirm={handleRevisionLegalConfirm}
                onCancel={() => setOpenConfirmationRevisionLegal(false)}
                action="Approve"
              />

              <Dialog
                open={saveAndSendConfirmationSubmit}
                onClose={() => {
                  setSaveAndSendConfirmationSubmit(false);
                  setSaveAndSendConfirmationValue("");
                }}
              >
                <form
                  onSubmit={() => {
                    setOpenConfirmationRevision(false);
                    setOpenConfirmationSubmit(true);
                  }}
                >
                  <DialogContent>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={saveAndSendConfirmationValue}
                        onChange={(e) =>
                          setSaveAndSendConfirmationValue(e.target.value)
                        }
                      >
                        <FormControlLabel
                          value="SK"
                          control={<Radio />}
                          label="Send Surat Kuasa Only"
                        />
                        <FormControlLabel
                          value="DM"
                          control={<Radio />}
                          label="Send Dokumen Master Only"
                        />
                        <FormControlLabel
                          value="DMSK"
                          control={<Radio />}
                          label="Send Dokumen Master with Surat Kuasa"
                        />
                      </RadioGroup>
                    </FormControl>
                  </DialogContent>

                  <DialogActions
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      color={
                        saveAndSendConfirmationValue == ""
                          ? "secondary"
                          : "primary"
                      }
                      disabled={saveAndSendConfirmationValue == ""}
                      style={{ textTransform: "capitalize" }}
                    >
                      Send Email
                    </Button>
                  </DialogActions>
                </form>
              </Dialog>

              <Dialog
                open={resendConfirmationSubmit}
                onClose={() => {
                  setResendConfirmationSubmit(false);
                  setResendConfirmationValue("");
                }}
              >
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setOpenConfirmationResend(true);
                    setResendConfirmationSubmit(false);
                  }}
                >
                  <DialogContent>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={resendConfirmationValue}
                        onChange={(e) =>
                          setResendConfirmationValue(e.target.value)
                        }
                      >
                        <FormControlLabel
                          value="SK"
                          control={<Radio />}
                          label="Resend Surat Kuasa Only"
                        />
                        <FormControlLabel
                          value="DM"
                          control={<Radio />}
                          label="Resend Dokumen Master Only"
                        />
                        <FormControlLabel
                          value="DMSK"
                          control={<Radio />}
                          label="Resend Dokumen Master with Surat Kuasa"
                        />
                      </RadioGroup>
                    </FormControl>
                  </DialogContent>

                  <DialogActions
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenConfirmationResend(true);
                        setResendConfirmationSubmit(false);
                      }}
                      type="button"
                      variant="contained"
                      color={
                        resendConfirmationValue == "" ? "secondary" : "primary"
                      }
                      disabled={resendConfirmationValue == ""}
                      style={{ textTransform: "capitalize" }}
                    >
                      Resend Email
                    </Button>
                  </DialogActions>
                </form>
              </Dialog>
            </TabPanel>

            <TabPanel value={valueTab} index={2}>
              <TransactionHistoryModal />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(1)}
                >
                  {"<<"} Previous Page
                </Button>
              </Box>
            </TabPanel>

            <Loading open={loadingActive} />

            <Feedback
              open={openFeedback}
              message={feedbackText}
              feedbackType={feedbackType}
              onClose={() => {
                if (feedbackType == "failed") {
                  setOpenFeedback(false);
                }
              }}
            />
          </form>
        )}
      </Formik>
    </Container>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export default ApprovalLR;
